import {
  ModalProvider,
  SecurityRoute,
  SecurityRoutes,
  Sidebar,
  SidebarItem,
  SidebarProfile,
  spacing,
  ToastContainer,
} from "@litbase/alexandria";
import { BrowserRouter, Navigate, Outlet, Route } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light-border.css";
import { GlobalStyle, theme } from "@diacare/common/styles/theme-types";
import { client } from "@litbase/client";
import { isEmptyUser } from "@litbase/core";
import { useCurrentUser } from "@litbase/react";
import { Bell, QuestionMark, User } from "@styled-icons/boxicons-regular";
import styled, { ThemeProvider } from "styled-components";
import { AcceptInvitePage } from "./admin-pages/accept-invite-page";
import { LoginPage } from "./admin-pages/login-page";
import { NotificationEditPage } from "./admin-pages/notification-edit-page";
import { NotificationListPage } from "./admin-pages/notification-list-page";
import { QuestionEditPage } from "./admin-pages/question-edit-page";
import { QuestionListPage } from "./admin-pages/question-list-page";
import { UserEditPage, UserListPage } from "./admin-pages/users-admin";
import { LitbaseDataProvider } from "./utils/listbase-data-provider";

export function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <BrowserRouter>
        <LitbaseDataProvider>
          <ModalProvider>
            <div>
              <SecurityRoutes>
                <SecurityRoute
                  isGranted="IS_AUTHENTICATED"
                  fallback="/login"
                  path="/*"
                  element={
                    <Row>
                      {/* @ts-ignore */}
                      <Sidebar profile={<SidebarProfileSection />}>
                        <SidebarItem name="Users" icon={User}>
                          <SidebarItem to="/users" name="Users" />
                          <SidebarItem to="/users/new" name="New user" />
                        </SidebarItem>
                        <SidebarItem name="Questions" icon={QuestionMark}>
                          <SidebarItem to="/questions/hu" name="Questions" />
                          <SidebarItem to="/questions/edit/new" name="New question" />
                        </SidebarItem>
                        <SidebarItem name="Notifications" icon={Bell}>
                          <SidebarItem to="/notifications" name="Notifications" />
                          <SidebarItem to="/notifications/edit/new" name="New notification" />
                        </SidebarItem>
                      </Sidebar>
                      <Col>
                        <ContainerCol>
                          <Outlet />
                        </ContainerCol>
                      </Col>
                    </Row>
                  }
                >
                  <Route path="users" element={<UserListPage />} />
                  <Route path="users/:id" element={<UserEditPage />} />
                  <Route path="questions/:lang" element={<QuestionListPage />} />
                  <Route path="questions/edit/:id" element={<QuestionEditPage />} />
                  <Route path="notifications" element={<NotificationListPage />} />
                  <Route path="notifications/edit/:id" element={<NotificationEditPage />} />
                  <Route path="*" element={<Navigate to="/users" />} />
                </SecurityRoute>
                {/* Unatuhenticated routes */}
                <SecurityRoute isGranted="IS_NOT_AUTHENTICATED" path="/login" fallback="/" element={<LoginPage />} />
                <SecurityRoute
                  isGranted="IS_NOT_AUTHENTICATED"
                  path="/accept-invite/:token"
                  fallback="/"
                  element={<AcceptInvitePage />}
                />
                {/* Fallback route */}
                <SecurityRoute
                  isGranted="IS_AUTHENTICATED"
                  path="*"
                  fallback="/login"
                  element={<Navigate to="/questions/hu" />}
                />
              </SecurityRoutes>
            </div>
          </ModalProvider>
        </LitbaseDataProvider>
        <ToastContainer position="top-right" />
      </BrowserRouter>
    </ThemeProvider>
  );
}

const ContainerCol = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1020px;
  margin: 0 auto;
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  height: 100%;
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${spacing._4};
  flex: 1;
`;

function SidebarProfileSection() {
  const user = useCurrentUser();
  return <SidebarProfile name={user?.name} isLoading={isEmptyUser(user)} onLogout={() => client.logout()} />;
}
